const DATASET = 'data-network-switching';

export const requestEndpoint = (url, method, body) => fetch(url, {
    method: method || 'GET',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
    },
    body: new URLSearchParams(body),
}).then(res => res.json());

const checkConsent = (networkSwitchingConsentInput, networkSwitchingContent) => {
    if (networkSwitchingConsentInput.checked) {
        networkSwitchingContent.removeAttribute('hidden');
    } else {
        networkSwitchingContent.setAttribute('hidden', 'hidden');
    }
};

const toggleDisabledAttr = (node, condition) => node.disabled = !condition;
const toggleReadOnly = (node, readOnly) => node.readOnly = readOnly;
const clearInputValue = node => node.value = '';
const toggleHidden = (node, condition) => {
    if (condition) {
        node.classList.add('hidden');
    } else {
        node.classList.remove('hidden');
    }
};

const updatePhoneNumberLabel = (networkSwitchingForm, selectedOptionValue, publicId) => {
    if (selectedOptionValue === 'no') {
        return;
    }
    const phoneNumberInput = networkSwitchingForm
        .querySelector(`[data-network-switching-phone-number_${publicId}]`);
    const phoneNumberLabel = networkSwitchingForm
        .querySelector(`label[for=${phoneNumberInput.id}]`);
    const appendedText = selectedOptionValue === 'pac' ? 'keep' : 'cancel';
    phoneNumberLabel.textContent = `Mobile number you wish to ${appendedText}`;
};

const updateConsentLabels = (networkSwitchingForm, selectedOptionValue, publicId) => {
    if (selectedOptionValue === 'no') {
        return;
    }

    const networkSwitchingConsentInput = networkSwitchingForm.querySelector(`[${DATASET}-confirmation_${publicId}]`);
    const networkSwitchingButton = networkSwitchingForm.querySelector(`[${DATASET}-button_${publicId}]`);
    const networkSwitchingConsentLabel = networkSwitchingForm.querySelector(`label[for=${networkSwitchingConsentInput.id}]`);
    const networkSwitchingConsentType = networkSwitchingConsentLabel.querySelector('[data-switch-type]');

    networkSwitchingConsentType.textContent = selectedOptionValue.toUpperCase();
    networkSwitchingButton.textContent = selectedOptionValue === 'pac' ? 'Confirm Number Transfer' : 'Confirm Close Account';
};

const setFieldsetsStates = (networkSwitchingForm, publicId) => {
    const networkSwitchingInput = document.querySelector(`input[data-basket-id="${publicId}"]`);
    const dealNetworkSwitchingDecisionCodeInput = document.querySelector(`input[data-basket-decision-code="${publicId}"]`);

    if (!networkSwitchingInput || !dealNetworkSwitchingDecisionCodeInput) {
        return;
    }
    const decisionCodeValue = dealNetworkSwitchingDecisionCodeInput.value.trim();

    // IDM-7262
    // const radioRelatedInputs = networkSwitchingForm
    //     .querySelectorAll(`[${DATASET}-type]`);
    // const radioRelatedInput = networkSwitchingForm.querySelector(
    //     `[${DATASET}-type="${checkedRadioInput.value}"]`
    // );
    toggleDisabledAttr(networkSwitchingForm, decisionCodeValue !== 'no');
    // radioRelatedInputs.forEach((radioInput) => {
    //     toggleDisabledAttr(radioInput, radioInput === radioRelatedInput);
    //     networkSwitchingFieldset.querySelector(`label[for=${radioInput.id}]`).toggleAttribute('hidden', radioInput !== radioRelatedInput);
    // });
    updatePhoneNumberLabel(networkSwitchingForm, decisionCodeValue, publicId);
    updateConsentLabels(networkSwitchingForm, decisionCodeValue, publicId);
    const codeInput = networkSwitchingForm.querySelector(`.basket-network-switching-input-code-${publicId}`);
    const phoneInput = networkSwitchingForm.querySelector(`[${DATASET}-phone-number_${publicId}]`);

    if (decisionCodeValue === 'no') {
        if (codeInput) {
            codeInput.dataset.validate = false;
        }
        if (phoneInput) {
            phoneInput.dataset.validate = false;
        }
    } else {
        if (codeInput) {
            codeInput.dataset.validate = true;
        }
        if (phoneInput) {
            phoneInput.dataset.validate = true;
        }
    }
    $('#details-form').validator('update');
};

const updateFeedback = (formFeedback, message) => {
    formFeedback.innerHTML = message;
    formFeedback.removeAttribute('hidden', 'hidden');
};

const cloneForm = (form, submitConfirmation) => {
    let clone = document.createElement('form');
    let inputs = form.querySelectorAll(
        'input:not([data-non-submission-field]), select:not([data-non-submission-field])'
    );

    for (let i = 0; i < inputs.length; i++) {
        clone.appendChild(inputs[i].cloneNode(true));
    }

    if (submitConfirmation) {
        let input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'applyNetworkSwitchingConsent');
        input.setAttribute('value', '1');
        clone.appendChild(input);
    }

    return clone;
};

const requestAvailableSwitchingDates = (event, networkSwitchingDateSelect) => {
    const form = event.target.closest(`[${DATASET}]`);
    const publicId = form.querySelector('input[name="publicId"]').value;
    const switchCode = form.querySelector(`[${DATASET}-type]:not([disabled])`);
    const phoneNumber = form.querySelector(`[${DATASET}-phone-number]`);
    const formFeedback = form.querySelector(`[${DATASET}-feedback_${publicId}]`);
    if (
        switchCode.value == '' ||
        phoneNumber.value == '' ||
        phoneNumber.parentElement.classList.contains('has-error') ||
        switchCode.parentElement.classList.contains('has-error')
    ) {
        return;
    }
    const loader = document.querySelector('[data-loading-overlay]');
    event.preventDefault();
    loader.dataset.activeTasks = 1;
    formFeedback.setAttribute('hidden', 'hidden');

    requestEndpoint(
        form.dataset.networkSwitchingAddEndpoint,
        'POST',
        new FormData(cloneForm(form))
    )
        .then((data) => {
            if (data.result === 'success') {
                form.setAttribute(`data-network-switching-dirty_${publicId}`, '1');
                form.dataset.networkSwitchingDirty = 1;
                populateAvailableDates(data.availableDates, networkSwitchingDateSelect);
                $(`[data-network-switching-change-span_${publicId}]`).removeClass('hidden');
            } else {
                throw new Error(data.message);
            }
        })
        .catch(error => updateFeedback(formFeedback, error.message))
        .finally(() => loader.dataset.activeTasks = 0);
};

const clearSwitchingPreferences = (event) => {
    const form = event.target.closest(`[${DATASET}]`);
    const publicId = form.querySelector('input[name="publicId"]').value;
    const formFeedback = document.querySelector(`[${DATASET}-feedback_${publicId}]`);
    const loader = document.querySelector('[data-loading-overlay]');

    event.preventDefault();
    loader.dataset.activeTasks = 1;
    formFeedback.setAttribute('hidden', 'hidden');

    requestEndpoint(
        form.dataset.networkSwitchingClearEndpoint,
        'POST',
        new FormData(cloneForm(form, false))
    )
        .then((data) => {
            if (data.result === 'success') {
                form.setAttribute(`data-network-switching-dirty_${publicId}`, '0');
                form.dataset.networkSwitchingDirty = 0;
            } else {
                throw new Error(data.message);
            }
        })
        .catch(error => updateFeedback(formFeedback, error.message))
        .finally(() => loader.dataset.activeTasks = 0);
};

const submitConsent = (event) => {
    const form = event.target.closest(`[${DATASET}]`);
    const publicId = form.querySelector('input[name="publicId"]').value;
    const formFeedback = document.querySelector(`[${DATASET}-feedback_${publicId}]`);
    const loader = document.querySelector('[data-loading-overlay]');

    let formData;
    if (event.target.classList.contains('update-date-button')) {
        const selectedDateOption = form.querySelector('select[name$="[switchingDate]"] option:checked');
        const selectedDate = selectedDateOption ? selectedDateOption.value : '';
        formData = getCalendarRefreshFormData(form, publicId, selectedDate);
        formData.push(['applyNetworkSwitchingConsent', 1]);
    } else {
        formData = new FormData(cloneForm(form, true));
    }

    event.preventDefault();
    loader.dataset.activeTasks = 1;
    formFeedback.setAttribute('hidden', 'hidden');

    requestEndpoint(
        form.dataset.networkSwitchingAddEndpoint,
        'POST',
        formData
    )
        .then((data) => {
            if (data.result === 'success') {
                const phoneNumber = form.querySelector(`[${DATASET}-phone-number]`);
                const codeType = form.querySelector(`[${DATASET}-type]`);

                let dateSelected = new Date(data.date.date.replace(/ /g, 'T'));
                let dd = dateSelected.getDate().toString();
                let mm = (dateSelected.getMonth() + 1).toString();
                const yy = dateSelected.getFullYear().toString().substr(-2);

                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                dateSelected = dd + '/' + mm + '/' + yy;

                phoneNumber && toggleReadOnly(phoneNumber, true);
                codeType && toggleReadOnly(codeType, true);

                form.querySelector(`[${DATASET}-available-dates_${publicId}]`).parentElement.classList.add('hidden');
                form.querySelector(`[${DATASET}-confirm_${publicId}]`).classList.add('hidden');
                form.querySelector(`[${DATASET}-confirmation_${publicId}]`).disabled = true;
                form.querySelector(`[${DATASET}-button_${publicId}]`).disabled = true;
                form.querySelector(`[${DATASET}-message_${publicId}]`).innerHTML = '<span class="brand-erminto-icon check valign-middle margin-right-plus-5px"></span>' + dateSelected + ' has been requested as your switch date.';
                form.querySelector(`[${DATASET}-success_${publicId}]`).classList.remove('hidden');

                // start
                const cancelSwitchElement = document.querySelector(`[${DATASET}-cancel-switch_${publicId}]`);
                if (cancelSwitchElement && cancelSwitchElement.classList.contains('hidden')) {
                    cancelSwitchElement.classList.remove('hidden');
                }

                const switchingDefaultContent = document.querySelector(`.data-network-switching-switching-default-content_${publicId}`);
                if (switchingDefaultContent && !switchingDefaultContent.classList.contains('hidden')) {
                    switchingDefaultContent.classList.add('hidden');
                }

                const staticText = document.querySelector(`.data-network-switching-static-text_${publicId}`);
                if (staticText && !staticText.classList.contains('hidden')) {
                    staticText.classList.add('hidden');
                }

                const switchDate = document.querySelector(`.network-switching__switch-date-${publicId}`);
                if (switchDate && !switchDate.classList.contains('hidden')) {
                    switchDate.classList.add('hidden');
                }

                const feedback = document.querySelector(`.network-switching__feedback-${publicId}`);
                if (feedback && !feedback.classList.contains('hidden')) {
                    feedback.classList.add('hidden');
                }

                const dateLabel = document.querySelector(`.data-network-switching-date-lable_${publicId}`);
                if (dateLabel && !dateLabel.classList.contains('hidden')) {
                    dateLabel.classList.add('hidden');
                }

                const checkTriggers = document.querySelector(`.data-network-switching-check-triggers_${publicId}`);
                if (checkTriggers && !checkTriggers.classList.contains('hidden')) {
                    checkTriggers.classList.add('hidden');
                }

                const cancelSwitchBtn = form.querySelector(`[data-network-switching-cancel-switch_${publicId}]`);
                if (cancelSwitchBtn && cancelSwitchBtn.classList.contains('hidden')) {
                    cancelSwitchBtn.classList.remove('hidden');
                }
                // end
                const eSimNotice = form.querySelector(`[${DATASET}-esim]`);
                eSimNotice && toggleHidden(eSimNotice, true);
            } else {
                throw new Error(data.message);
            }
        })
        .catch(error => updateFeedback(formFeedback, error.message))
        .finally(() => loader.dataset.activeTasks = 0);
};

const bindConsentEvents = (networkSwitchingForm, publicId) => {
    // const networkSwitchingConsentInput = networkSwitchingFieldset.querySelector(`[${DATASET}-consent]`);
    // const networkSwitchingContent = networkSwitchingFieldset.querySelector(`[${DATASET}-content]`);
    const networkSwitchingConsentInput = networkSwitchingForm.querySelector(`[${DATASET}-confirmation_${publicId}]`);
    const networkSwitchingContent = networkSwitchingForm.querySelector(`[${DATASET}-confirmation_${publicId}]`);

    if (!networkSwitchingConsentInput || !networkSwitchingContent) {
        return;
    }

    networkSwitchingConsentInput.addEventListener('input', () => {
        checkConsent(networkSwitchingConsentInput, networkSwitchingContent);
    });

    checkConsent(networkSwitchingConsentInput, networkSwitchingContent);
};

const bindAvailableDatesEvents = (networkSwitchingDateSelect, networkSwitchingForm) => {
    networkSwitchingDateSelect.addEventListener('change', (event) => {
        const selectedIndex = event.target.selectedIndex;
        const publicId = networkSwitchingForm.querySelector('input[name="publicId"]').value;
        const confirmation = networkSwitchingForm.querySelector(`[${DATASET}-confirmation_${publicId}]`);
        const button = networkSwitchingForm.querySelector(`[${DATASET}-button_${publicId}]`);
        const confirm = networkSwitchingForm.querySelector(`[${DATASET}-confirm_${publicId}]`);
        const dateOptions = networkSwitchingForm.querySelector(`[${DATASET}-available-dates_${publicId}]`).querySelectorAll(':scope option');

        for (const element of dateOptions) {
            element.removeAttribute('selected');
        }

        event.target.options[selectedIndex].setAttribute('selected', 'selected');

        toggleDisabledAttr(confirmation, event.target.value);
        toggleDisabledAttr(button, event.target.value);
        toggleHidden(confirm, !event.target.value);
        confirmation.dataset.validate = true;
        $(`.${DATASET}-check-btn_${publicId}`).addClass('hide');
        $('#details-form').validator('update');
    });
};
// IDM-7262 old code
// const bindSwitchingCheckEvents = (networkSwitchingForm, networkSwitchingDateSelect) => {
//     const checkTriggers = networkSwitchingForm.querySelector(`[${DATASET}-check-triggers]`);
//     const networkSwitchingValidate = networkSwitchingForm.querySelector('[data-network-switching-validate]');
//     if (!checkTriggers) {
//         return;
//     }
//     // On click of Verify button pac/stac validation should happen
//     networkSwitchingValidate.addEventListener('click', (e) => {
//         requestAvailableSwitchingDates(e, networkSwitchingDateSelect);
//     });
// };

// IDM-7262 code reverted

const bindSwitchingCheckVerifyButton = (networkSwitchingForm, networkSwitchingDateSelect) => {

    // On click of Verify button pac/stac single input switch according to the input IDM-7262.

    if (!networkSwitchingForm) {
        return;
    }
    // On click of Verify button pac/stac validation should happen
    networkSwitchingForm.addEventListener('click', (e) => {
        const verifyButton = e.target.closest('button[data-network-switching-validate]');

        if (!verifyButton) {
            return;
        }

        const basketPublicId = verifyButton.getAttribute('data-network-switching-verify-basket-id');
        if (!basketPublicId) {
            return;
        }

        const networkSwitchingInput = document.querySelector(`input[data-basket-id="${basketPublicId}"]`);
        const dealNetworkSwitchingDecisionCodeInput = document.querySelector(`input[data-basket-decision-code="${basketPublicId}"]`);
        // const dealNetworkSwitchingDecisionCodeInput = document.querySelector(`input[name="form[${basketPublicId}-networkSwitching][networkSwitchingDecision]"][data-basket-decision-code="${basketPublicId}"]`);

        if (!networkSwitchingInput || !dealNetworkSwitchingDecisionCodeInput) {
            return;
        }
        const errorMsg = networkSwitchingInput.dataset.error;

        const pacRegex = /^[A-Za-z]{3}[0-9]{6}$/;
        const stacRegex = /^[0-9]{6}[A-Za-z]{3}$/;

        const networkSwitchinValue = networkSwitchingInput.value.trim();
        $(`input[type="radio"][name="form[${basketPublicId}-networkSwitching][networkSwitchingDecision]"]`).prop('checked', false);
        if (pacRegex.test(networkSwitchinValue)) {
            $(`input[type="radio"][name="form[${basketPublicId}-networkSwitching][networkSwitchingDecision]"][value="pac"]`).prop('checked', true);
            networkSwitchingInput.dataset.validate = 'false';
            networkSwitchingInput.id = `form_${basketPublicId}-networkSwitching_networkSwitchingPacCode`;
            networkSwitchingInput.name = `form[${basketPublicId}-networkSwitching][networkSwitchingPacCode]`;
            networkSwitchingInput.dataset.networkSwitchingType = 'pac';
            dealNetworkSwitchingDecisionCodeInput.dataset.networkSwitchingDecision = 'pac';
            dealNetworkSwitchingDecisionCodeInput.value = 'pac';
            setFieldsetsStates(networkSwitchingForm, basketPublicId);
            // On click of Verify button pac/stac validation should happen
        } else if (stacRegex.test(networkSwitchinValue)) {
            $(`input[type="radio"][name="form[${basketPublicId}-networkSwitching][networkSwitchingDecision]"][value="stac"]`).prop('checked', true);

            const inputNetworkSwitchingStacCode = $(`#form_${basketPublicId}-networkSwitching_networkSwitchingStacCode:not([data-basket-id])`);
            if (inputNetworkSwitchingStacCode.length > 0) {
                inputNetworkSwitchingStacCode.val(networkSwitchinValue);
            }
            networkSwitchingInput.dataset.validate = 'false';
            networkSwitchingInput.id = `form_${basketPublicId}-networkSwitching_networkSwitchingStacCode`;
            networkSwitchingInput.name = `form[${basketPublicId}-networkSwitching][networkSwitchingStacCode]`;
            networkSwitchingInput.dataset.networkSwitchingType = 'stac';
            dealNetworkSwitchingDecisionCodeInput.dataset.networkSwitchingDecision = 'stac';
            dealNetworkSwitchingDecisionCodeInput.value = 'stac';
            setFieldsetsStates(networkSwitchingForm, basketPublicId);
        } else {
            $(`input[type="radio"][name="form[${basketPublicId}-networkSwitching][networkSwitchingDecision]"][value="no"]`).prop('checked', true);
            networkSwitchingInput.dataset.error = errorMsg;
            dealNetworkSwitchingDecisionCodeInput.dataset.networkSwitchingDecision = 'no';
            dealNetworkSwitchingDecisionCodeInput.value = 'no';
            return;
        }
        networkSwitchingInput.dataset.validate = 'true';
        $('#details-form').validator('update');
        requestAvailableSwitchingDates(e, networkSwitchingDateSelect);
    });
    return;
    // end
};

const networkSwitching = () => {
    const networkSwitchingForms = document.querySelectorAll(`[${DATASET}]`);

    if (!networkSwitchingForms.length) {
        return;
    }

    networkSwitchingForms.forEach((networkSwitchingForm) => {
        const publicId = networkSwitchingForm.querySelector('input[name="publicId"]').value;
        const networkSwitchingRadioInputs = networkSwitchingForm.querySelectorAll(
            `[${DATASET}-decision] input[type="radio"]`
        );
        const networkSwitchingFieldset = networkSwitchingForm.querySelector(`[${DATASET}-fieldset_${publicId}]`);
        const networkSwitchingDateSelect = networkSwitchingForm.querySelector(`[${DATASET}-available-dates_${publicId}]`);
        const networkSwitchingButton = networkSwitchingForm.querySelector(`[${DATASET}-button_${publicId}]`);
        const codeInputs = networkSwitchingForm.querySelectorAll(`[${DATASET}-type]`);
        networkSwitchingRadioInputs.forEach((networkSwitchingRadioInput) => {
            networkSwitchingRadioInput.addEventListener('input', (e) => {
                resetForm(e, networkSwitchingForm);
                setFieldsetsStates(networkSwitchingRadioInputs, networkSwitchingFieldset);
            });
        });
        if (networkSwitchingButton) {
            networkSwitchingButton.addEventListener('click', (e) => {
                const confirm = networkSwitchingForm.querySelector(`[${DATASET}-confirm_${publicId}]`);
                const confirmation = networkSwitchingForm.querySelector(`[${DATASET}-confirmation_${publicId}]`);
                if (!confirmation.checked) {
                    confirm.classList.add('has-error', 'has-danger');
                    return;
                }
                submitConsent(e);
            });
        }
        codeInputs.forEach(input => input.addEventListener('keyup', () =>
            input.value = input.value.toUpperCase()
        ));
        bindConsentEvents(networkSwitchingForm, publicId);
        if (networkSwitchingDateSelect) {
            bindAvailableDatesEvents(networkSwitchingDateSelect, networkSwitchingForm);
        }
        // bindSwitchingCheckEvents(networkSwitchingForm, networkSwitchingDateSelect); // IDM-7262 hide
        bindSwitchingCheckVerifyButton(networkSwitchingForm, networkSwitchingDateSelect);
        // if (networkSwitchingFieldset) {
        setFieldsetsStates(networkSwitchingForm, publicId);
        // }
    });
};

export const populateAvailableDates = (availableDates, networkSwitchingDateSelect) => {
    const placeholderOption = networkSwitchingDateSelect.querySelector('option[value=""]');
    let availableDatesValues = [];
    networkSwitchingDateSelect.innerHTML = '';
    networkSwitchingDateSelect.append(placeholderOption);
    availableDates.map((availableDate) => {
        let option = document.createElement('option');
        option.value = availableDate.value;
        option.innerHTML = availableDate.label;
        networkSwitchingDateSelect.append(option);
    });
    networkSwitchingDateSelect.disabled = false;
    networkSwitchingDateSelect.parentElement.parentElement.classList.remove('hidden');
    for (var i = 0; i < availableDates.length; i++) {
        availableDatesValues.push(availableDates[i].value);
    }
    const datepickerInput = networkSwitchingDateSelect.closest('.network-switching').querySelector('[data-datepicker-switching]');
    createCalendar(availableDatesValues, datepickerInput);
    // data-network-switching-change-span
    const publicId = networkSwitchingDateSelect.closest('.network-switching').querySelector('input[name="publicId"]').value;
    $(`[data-network-switching-change-span_${publicId}]`).removeClass('hidden');
    networkSwitchingDateSelect.dataset.validate = true;
    datepickerInput.dataset.validate = true;
    $('#details-form').validator('update');
};

const resetForm = (e, form) => {
    const publicId = form.querySelector('input[name="publicId"]').value;
    const phoneNumber = form.querySelector(`[${DATASET}-phone-number]`);
    const codeType = form.querySelectorAll(`[${DATASET}-type]`);
    const availableDates = form.querySelector(`[${DATASET}-available-dates_${publicId}]`);
    const confirm = form.querySelector(`[${DATASET}-confirm_${publicId}]`);
    const confirmation = form.querySelector(`[${DATASET}-confirmation_${publicId}]`);
    const button = form.querySelector(`[${DATASET}-button_${publicId}]`);
    const success = form.querySelector(`[${DATASET}-success_${publicId}]`);
    const networkSwitchingDirtyElement = document.querySelector(`[data-network-switching-dirty_${publicId}]`);
    const networkSwitchingDirtyVal = networkSwitchingDirtyElement.getAttribute(`data-network-switching-dirty_${publicId}`);
    clearInputValue(phoneNumber);
    toggleReadOnly(phoneNumber, false);

    codeType.forEach((element) => {
        clearInputValue(element);
        toggleReadOnly(element, false);
    });

    clearInputValue(availableDates);
    const dateOptions = form.querySelector(`[${DATASET}-available-dates_${publicId}]`).querySelectorAll(':scope option');

    for (const element of dateOptions) {
        element.removeAttribute('selected');
    }
    availableDates.options[0].setAttribute('selected', 'selected');
    availableDates.parentElement.classList.remove('hidden');
    availableDates.parentElement.parentElement.classList.add('hidden');

    confirm.classList.remove('has-error', 'has-danger');

    if (confirmation) {
        confirmation.checked = false;
    }
    const datepickerInput = form.querySelector(`[data-datepicker-switching-${publicId}]`);
    if (datepickerInput) {
        datepickerInput.value = '';
        if (datepickerInput.calendarInstance) {
            try {
                datepickerInput.calendarInstance.setDate(null);
            } catch (e) {
                // ignore if version does not support setDate(null)
            }
        }
    }

    toggleHidden(confirm, true);
    toggleDisabledAttr(confirmation, false);
    toggleDisabledAttr(button, false);
    toggleHidden(success, true);
    const wrapperSuccess = document.querySelector(
        `[data-network-switching-success_${publicId}]`
    );

    if (wrapperSuccess) {
        wrapperSuccess.classList.add('hidden');
    }

    phoneNumber.dataset.validate = false;
    codeType.forEach((element) => {
        element.dataset.validate = false;
    });
    availableDates.dataset.validate = false;
    confirmation.dataset.validate = false;

    $('#details-form').validator('update');
    if (networkSwitchingDirtyVal == 1) {
        clearSwitchingPreferences(e);
    }

    destroyCalendar();
};

const destroyCalendar = () => {
    if (typeof calendarSwitching != 'undefined' && calendarSwitching != null && Object.getOwnPropertyNames(calendarSwitching).length !== 0) {
        calendarSwitching.remove();
    }
};

export default networkSwitching;

import datepicker from 'js-datepicker';

function dateNoTime(date) {
    return date.setHours(0, 0, 0, 0);
}

function validateDatepicker(instance) {
    const dateSelected = instance.dateSelected;
    const el = instance.el;
    const parent = instance.parent;
    if (typeof dateSelected == 'undefined' || dateSelected == null) {
        parent.classList.add('has-error');
        el.nextElementSibling.innerHTML = '<ul class="list-unstyled"><li>Please select the date you would like the switch to occur on</li></ul>';
    } else {
        parent.classList.remove('has-error');
        el.nextElementSibling.innerHTML = '';
    }
}

function createCalendar(availableDatesValues, datepickerSwitching) {
    const firstDateAvailable = availableDatesValues[0];
    const lastDateAvailable = availableDatesValues[availableDatesValues.length - 1];

    if (typeof datepickerSwitching != 'undefined' && datepickerSwitching != null) {
        // destroyCalendar();
        if (datepickerSwitching.calendarInstance) {
            datepickerSwitching.calendarInstance.remove();
        }
        // const availableDatesSelect = document.querySelector('[data-network-switching-available-dates]');
        const availableDatesSelect = datepickerSwitching.closest('.network-switching').querySelector('[data-network-switching-available-dates]');
        let disabledDates = [];

        for (let d = new Date(firstDateAvailable); d <= new Date(lastDateAvailable); d.setDate(d.getDate() + 1)) {
            let dateAvailable = false;

            for (var i = 0; i < availableDatesValues.length; i++) {
                let calendarDate = dateNoTime(d);
                let arrayDate = dateNoTime(new Date(availableDatesValues[i]));

                if (calendarDate == arrayDate) {
                    dateAvailable = true;
                    break;
                }
            }
            if (!dateAvailable) {
                disabledDates.push(new Date((d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear()));
            }
        }
        datepickerSwitching.calendarInstance = datepicker(datepickerSwitching, {
            startDay: 1,
            minDate: new Date(firstDateAvailable),
            maxDate: new Date(lastDateAvailable),
            disableYearOverlay: true,
            disabledDates: disabledDates,
            formatter: (input, date) => {
                const value = date.toLocaleDateString();
                input.value = value;
            },
            onSelect: (instance) => {
                availableDatesSelect.querySelectorAll(':scope option').forEach((element) => {
                    element.removeAttribute('selected');
                });
                availableDatesSelect.querySelector(':scope option[value="' + instance.dateSelected.getFullYear() + '-' + (instance.dateSelected.getMonth() + 1).toString().padStart(2, '0') + '-' + (instance.dateSelected.getDate()).toString().padStart(2, '0') + '"]').setAttribute('selected', 'selected');
                availableDatesSelect.dispatchEvent(new Event('change'));
            },
            onHide: (instance) => {
                validateDatepicker(instance);
            }
        });
        availableDatesSelect.parentNode.classList.add('sr-only');
        availableDatesSelect.parentNode.previousElementSibling.classList.add('sr-only');
        datepickerSwitching.classList.remove('hidden');
    }
}

const getCalendarRefreshFormData = (networkSwitchingForm, publicId, date) => {
    const formKey = publicId + '-networkSwitching';
    const data = [['publicId', publicId]];
    const decisionInput = document.querySelector(`input[data-basket-decision-code="${publicId}"]`);
    // const decisionInput = networkSwitchingForm.getElementById(`form_${publicId}-networkSwitching_networkSwitchingDecision`);
    const decision = decisionInput.value.trim();

    data.push([
        `form[${formKey}][networkSwitchingMobileNumber]`,
        networkSwitchingForm.dataset.networkSwitchingMobileNumber
    ]);
    data.push([`form[${formKey}][networkSwitchingDecision]`, decision]);
    if (decision === 'pac') {
        data.push([
            `form[${formKey}][networkSwitchingPacCode]`,
            networkSwitchingForm.dataset.networkSwitchingPacCode
        ]);
    } else {
        // data.push([
        //     `form[${formKey}][networkSwitchingStacCode]`,
        //     networkSwitchingInput
        //     // networkSwitchingForm.dataset.networkSwitchingStacCode
        // ]);

        const networkSwitchingInputFeild = document.querySelector(`input[data-basket-id="${publicId}"]`);
        const dealNetworkSwitchingDecisionCodeInputFeild = document.querySelector(`input[data-basket-decision-code="${publicId}"]`);
        const networkSwitchinVal = networkSwitchingForm.dataset.networkSwitchingStacCode;
        const inputNetworkSwitchingStacCode = $(`#form_${publicId}-networkSwitching_networkSwitchingStacCode:not([data-basket-id])`);
        if (inputNetworkSwitchingStacCode.length > 0) {
            inputNetworkSwitchingStacCode.val(networkSwitchinVal);
        }
        networkSwitchingInputFeild.dataset.validate = 'false';
        networkSwitchingInputFeild.id = `form_${publicId}-networkSwitching_networkSwitchingStacCode`;
        networkSwitchingInputFeild.name = `form[${publicId}-networkSwitching][networkSwitchingStacCode]`;
        networkSwitchingInputFeild.dataset.networkSwitchingType = 'stac';
        dealNetworkSwitchingDecisionCodeInputFeild.dataset.networkSwitchingDecision = 'stac';
        dealNetworkSwitchingDecisionCodeInputFeild.value = 'stac';

        let inputNetworkSwitchingstacCode = document.querySelectorAll(`[name="form[${publicId}-networkSwitching][networkSwitchingStacCode]"]`);
        inputNetworkSwitchingstacCode.forEach((input, index) => {
            data.push([
                `form[${formKey}][networkSwitchingStacCode][${index}]`,
                networkSwitchingForm.dataset.networkSwitchingStacCode
            ]);
        });
    }
    data.push([`form[${formKey}][switchingDate]`, date]);
    return data;
};

export const refreshCalendar = (networkSwitchingForm, publicId) => {
    const formData = getCalendarRefreshFormData(networkSwitchingForm, publicId, '');
    const loader = document.querySelector('[data-loading-overlay]');
    const formFeedback = document.querySelector(`[${DATASET}-feedback]`);
    loader.dataset.activeTasks = parseInt(loader.dataset.activeTasks) + 1;
    return requestEndpoint(networkSwitchingForm.dataset.networkSwitchingAddEndpoint, 'POST', formData)
        .then(data => new Promise((resolve, reject) => {
            if (data.result !== 'success') {
                throw new Error(data.message);
            }
            if (data.availableDates) {
                const networkSwitchingDateSelect = networkSwitchingForm.querySelector('[data-network-switching-available-dates]');
                populateAvailableDates(data.availableDates, networkSwitchingDateSelect);
                // data-network-switching-change-span
                if (!$(`${DATASET}-change-span_${publicId}`).hasClass('hidden')) {
                    $(`${DATASET}-change-span_${publicId}`).addClass('hidden');
                }
                resolve(data);
            } else {
                reject(data);
            }
        })).catch(error => updateFeedback(formFeedback, error.message))
        .finally(() => loader.dataset.activeTasks = parseInt(loader.dataset.activeTasks) - 1);
};

window.addEventListener('load', () => {
    document
        .querySelectorAll('[data-datepicker-switching]')
        .forEach((datepickerInput) => {

            const dateChoices =
                datepickerInput.getAttribute('data-date-choices');

            if (!dateChoices) {
                return;
            }

            const dateChoicesArray = dateChoices
                .split(',')
                .filter(x => x);

            if (dateChoicesArray.length > 0) {
                createCalendar(
                    dateChoicesArray,
                    datepickerInput
                );
            }
        });
});

// modal on off

// Switching content control
$('.switching-button').on('click', function(event) {
    event.preventDefault();
    const publicId = $(this).data('public-id');
    const targetItem = `.basket-item[data-public-id=${publicId}]`;
    $(`#form_${publicId}-networkSwitching_networkSwitchingMobileNumber`).attr('data-validate', true);
    $('.basket-network-switching-input-code-' + publicId).attr('data-validate', true);
    $('.data-network-switching-fieldset-' + publicId).prop('disabled', false);

    $(`${targetItem} .switching-modal`).removeClass('hidden');
    $(`${targetItem} .switching-default-content`).addClass('hidden');
    $(`${targetItem} .switching-button`).addClass('hidden');
    $(`${targetItem} .switching-title`).text('Switch to iD Mobile');

    const staticcontent = document.querySelector(`.${DATASET}-default-content_${publicId}`);
    if (staticcontent && staticcontent.classList.contains('hidden')) {
        staticcontent.classList.remove('hidden');
    }

    const btnSwitch = document.querySelector(`.${DATASET}-btn-switch_${publicId}`);
    if (btnSwitch && btnSwitch.classList.contains('hidden')) {
        btnSwitch.classList.remove('hidden');
    }

    $('#details-form').validator('update');
});
$('.switching-modal .cancel').on('click', function(e) {
    e.preventDefault();
    const publicId = $(this).data('public-id');
    const targetItem = `.basket-item[data-public-id=${publicId}]`;
    const $form = $(this).closest('.switching-form');
    let $formGroup = $(this).closest('.switching-form').find('.form-group.switching-fields');
    $formGroup.removeClass('has-error has-danger');
    $formGroup.find('.help-block ul').remove();
    $(`input[type="radio"][name="form[${publicId}-networkSwitching][networkSwitchingDecision]"][value="no"]`).prop('checked', true);

    $(`#form_${publicId}-networkSwitching_networkSwitchingMobileNumber`).attr('data-validate', false);
    $(`#form_${publicId}-networkSwitching_networkSwitchingDecision`).attr('data-validate', false);
    $(`#form_${publicId}-networkSwitching_networkSwitchingDecision`).attr('data-network-switching-decision', 'no');
    $(`#form_${publicId}-networkSwitching_networkSwitchingDecision`).val('no');
    $('.basket-network-switching-input-code-' + publicId).attr('data-validate', false);

    $('.basket-network-switching-input-code-' + publicId).val('').removeAttr('readonly');
    $(`#form_${publicId}-networkSwitching_networkSwitchingMobileNumber`).val('').removeAttr('readonly');

    $form.find('[data-validate]').attr('data-validate', false);
    $form.find('[required]').prop('required', false);
    $('.data-network-switching-fieldset-' + publicId).prop('disabled', true);

    if (!$(`${targetItem} [data-network-switching-feedback_${publicId}]`).hasClass('hidden')) {
        $(`${targetItem} [data-network-switching-feedback_${publicId}]`).addClass('hidden');
    }

    if (!$(`${targetItem} .network-switching__switch-date_${publicId}`).hasClass('hidden')) {
        $(`${targetItem} .network-switching__switch-date_${publicId}`).addClass('hidden');
    }

    if ($(`.${DATASET}-check-btn_${publicId}`).hasClass('hide')) {
        $(`.${DATASET}-check-btn_${publicId}`).removeClass('hide');
    }

    resetForm(e, $form[0]);
    $(`${targetItem} .switching-modal`).addClass('hidden');
    $(`${targetItem} .switching-default-content`).removeClass('hidden');
    $(`${targetItem} .switching-button`).removeClass('hidden');
    $(`${targetItem} .switching-title`).text('Switching from another network?');
    $('#details-form').validator('update');
});

$('.switching-cancel-button').on('click', function(e) {
    e.preventDefault();
    // const form = e.target.closest(`[${DATASET}]`);

    const publicId = $(this).data('public-id');

    const clerswitchelement = document.querySelector(`[${DATASET}-cancel-switch_${publicId}]`);
    if (clerswitchelement && !clerswitchelement.classList.contains('hidden')) {
        clerswitchelement.classList.add('hidden');
    }

    const clerswitchdefaultcontentelt = document.querySelector(`[${DATASET}-switching-default-content_${publicId}]`);
    if (clerswitchdefaultcontentelt && clerswitchdefaultcontentelt.classList.contains('hidden')) {
        clerswitchdefaultcontentelt.classList.remove('hidden');
    }

    const clerswitchstaticsuccessmsg = document.querySelector(`[${DATASET}-static-success_${publicId}]`);
    if (clerswitchstaticsuccessmsg && !clerswitchstaticsuccessmsg.classList.contains('hidden')) {
        clerswitchstaticsuccessmsg.classList.add('hidden');
    }

    const clerswitchsuccessmsg = document.querySelector(`[${DATASET}-success_${publicId}]`);
    if (clerswitchsuccessmsg && !clerswitchsuccessmsg.classList.contains('hidden')) {
        clerswitchsuccessmsg.classList.add('hidden');
    }

    const statictext = document.querySelector(`.${DATASET}-static-text_${publicId}`);
    if (statictext && statictext.classList.contains('hidden')) {
        statictext.classList.remove('hidden');
    }

    const btnSwitch = document.querySelector(`.${DATASET}-btn-switch_${publicId}`);
    if (btnSwitch && btnSwitch.classList.contains('hidden')) {
        btnSwitch.classList.remove('hidden');
    }

    const checktriggerinputSwitch = document.querySelector(`.${DATASET}-check-triggers_${publicId}`);
    if (checktriggerinputSwitch && checktriggerinputSwitch.classList.contains('hidden')) {
        checktriggerinputSwitch.classList.remove('hidden');
    }

    // const changespanbtn = document.querySelector(`[data-network-switching-change-span_${publicId}]`);
    // if (changespanbtn) {
    //     changespanbtn.classList.add('hidden');
    // }
    $(`[data-network-switching-change-span_${publicId}]`).addClass('hidden');

    const modalCancelBtn = $(`.basket-item[data-public-id="${publicId}"] .switching-modal .cancel`).first();
    if (modalCancelBtn.length) {
        modalCancelBtn.trigger('click');
    }
});

// change span
$('.change_button').on('click', function(event) {
    event.preventDefault();

    const publicId = $(this).data('public-id');
    const $form = $(this).closest('.switching-form');
    const form = $form[0];

    // Reset form
    resetForm(event, form);

    // Mobile Number
    const mobileInput = $(
        `#form_${publicId}-networkSwitching_networkSwitchingMobileNumber`
    );

    mobileInput
        .val('')
        .prop('readonly', false)
        .attr('data-validate', false);

    // Decision = no
    const decisionInput = $(`#form_${publicId}-networkSwitching_networkSwitchingDecision`);
    decisionInput.val('no');
    decisionInput.attr('data-network-switching-decision', 'no');

    // PAC / STAC input
    const codeInput = $(`.basket-network-switching-input-code-${publicId}`);

    codeInput.val('').prop('readonly', false).attr('data-validate', false);
    // Hide success message
    $(`[data-network-switching-success_${publicId}]`).addClass('hidden');
    // Hide date section
    $(`.network-switching__switch-date-${publicId}`).addClass('hidden');
    // Hide change link itself
    $(this).addClass('hidden');
    // Show Verify button section
    $(`.data-network-switching-check-btn_${publicId}`).removeClass('hide').removeClass('hidden');
    // Show confirmation section hidden
    $(`[data-network-switching-confirm_${publicId}]`).addClass('hidden');
    // Enable fieldset
    $(`.data-network-switching-fieldset_${publicId}`).prop('disabled', false);
    // Show action buttons
    $(`button[data-network-switching-validate_${publicId}]`).removeClass('hidden');
    $(`.clear_inputs_network_switching_switching[data-public-id="${publicId}"]`).removeClass('hidden');
    // Show full form again
    $(`[data-network-switching-full-section_${publicId}]`).removeClass('hidden');
    // if (!form.querySelector(`[${DATASET}-cancel-switch_${publicId}]`).hasClass('hidden')) {
    //     form.querySelector(`[${DATASET}-cancel-switch_${publicId}]`).addClass('hidden');
    // }
    $('#details-form').validator('update');
});
